function applyGliderProva(){

  const glider = new Glider(document.querySelector(".gliderProva"), {
    slidesToShow: 3,
    dots: ".dots",
    draggable: false,
    scrollLock: false,
    arrows: {
      prev: ".glider-prev-prova",
      next: ".glider-next-prova"
    },
    responsive: [
      { // screens greater than >=300px
        breakpoint: 300,
        settings: { // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 1,
          slidesToScroll: "auto",

          duration: 0.25
        }
      }, { // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          itemWidth: 150,
          duration: 0.25
        }
      }
    ]
  })



}
applyGliderProva();


document.addEventListener('shopify:section:load', function(event){
  applyGliderProva();

});





